import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class FaqService {
	baseUrl: string = environment.API_SERVER;
	constructor(private _http: HttpClient) {}

	getFaqs(payload) {
		return this._http.get(this.baseUrl + '/admin/faq-all/', { params: payload.params });
	}
	addFaq(payload) {
		return this._http.post(`${this.baseUrl}/admin/faq/`, payload.body);
	}
	editFaq(payload) {
		return this._http.put(`${this.baseUrl}/admin/faq/${payload.FaqId}/`, payload.body);
	}

	removeFaq(payload) {
		return this._http.delete(`${this.baseUrl}/admin/faq/${payload.FaqId}/`);
	}
}
